/**
 * セクショングループ管理ナビゲーション専用i18n定数
 */

export const SECTION_GROUP_ADMIN_NAV_I18N = {
  // テーマ切替
  theme: {
    switchToDark: $localize`:@@sectionGroupAdmin.nav.theme.switchToDark:ダークモードに切替`,
    switchToSystem: $localize`:@@sectionGroupAdmin.nav.theme.switchToSystem:システム設定に切替`,
    switchToLight: $localize`:@@sectionGroupAdmin.nav.theme.switchToLight:ライトモードに切替`,
  },

  // ダイアログ
  dialog: {
    confirmTitle: $localize`:@@sectionGroupAdmin.nav.dialog.confirmTitle:ダイアログ確認`,
    confirmMessage: $localize`:@@sectionGroupAdmin.nav.dialog.confirmMessage:ダイアログが表示されます`,
  },
} as const;

export type SectionGroupAdminNavI18n = typeof SECTION_GROUP_ADMIN_NAV_I18N;
